module.exports = __webpack_public_path__ + "static/media/siri14.c1ce59a7.jpg";